import AlertIcon from '@components/alerticon';
import Typography from '@components/typography';
import { ModalContent } from 'interface';

export const invalidQuote = (closeModal: () => void) => {
  const buttons = (
    <a
      className="modal-content__body-buttons-button modal-content__body-buttons-button--primary"
      onClick={closeModal}
      data-testid="invalid-quote-close-button"
      href="#"
    >
      <Typography
        variant="caption"
        size="rg"
        weight="semi-bold"
        colour="alternative"
      >
        Close
      </Typography>
    </a>
  );
  return {
    icon: <AlertIcon />,
    title: 'Invalid quote configuration',
    message:
      'There is something wrong with current quote configuration. Please try changing the finance and/or services selection. Alternatively, please contact us and we will be happy to assist.',
    buttons: buttons,
  } as ModalContent;
};
